/** Read-only star rating display (rounded to whole stars). */
export function Stars({ value, count }: { value: number; count?: number }): JSX.Element {
  const full = Math.max(0, Math.min(5, Math.round(value)));
  return (
    <span aria-label={`${value.toFixed(1)} / 5`} style={{ color: 'var(--color-accent)' }}>
      {'★'.repeat(full)}
      {'☆'.repeat(5 - full)}
      {count != null ? <span className="muted">{` (${count})`}</span> : null}
    </span>
  );
}
